import './index.scss';
import React, { useEffect, useState, useRef, useMemo, MouseEvent } from 'react';
import { lang } from '@umu/ukit-lang';
import { SnackBar } from '@umu/umu-design';
import {
    ICooperationRole,
    getCourseActionPermission,
    getSessionActionPermission,
    getCooperationRoleName,
    cooperationShow,
} from '../../services/cooperationPermission';
import { ECooperationRole } from '@umu/umu-types';
export * from '../../services/cooperationPermission';

interface IProps {
    actionName: string;
    role?: ICooperationRole;
    children: JSX.Element | JSX.Element[] | string;
    cls?: string;
    tip?: string;
    reverse?: boolean;
    blockedHandle?: VoidFunction;
}
export const CooperationActionWrap = (props: IProps) => {
    const ref = useRef<HTMLDivElement>(null);
    const { cls = '', children, role, actionName, tip, reverse, blockedHandle } = props;
    const [className, setClassName] = useState(`react-cooperation-action-wrap ${cls}`);

    const permission = useMemo(() => {
        if (!role || !actionName.includes('.')) {
            return cooperationShow.available;
        }
        const [type, action] = actionName.split('.');
        if (type === 'course') {
            return getCourseActionPermission(role, action);
        }
        if (type === 'session') {
            return getSessionActionPermission(role, action);
        }
        return cooperationShow.available;
    }, [role, actionName]);

    useEffect(() => {
        const statusCls = permission === cooperationShow.disabled ? 'disabled' : '';
        setClassName(`react-cooperation-action-wrap ${cls} ${statusCls}`);
        if (ref && statusCls === 'disabled') {
            const btns = ref.current?.querySelectorAll('.umu-design-comp-btn') || [];
            Array.from(btns).forEach((btn) => {
                btn.setAttribute('disabled', 'true');
            });
        }
    }, [permission]);

    const onDisabledClick = (event: MouseEvent) => {
        if (permission !== cooperationShow.disabled) {
            return;
        }
        event.stopPropagation();
        if (typeof blockedHandle === 'function') {
            blockedHandle();
            return;
        }
        if (tip !== '') {
            const roleType = role?.role_type || ECooperationRole.creator;
            SnackBar.show(
                tip || lang('您的协同权限为{$1}，暂无该操作权限').replace('{$1}', getCooperationRoleName(roleType)),
            );
        }
    };

    if (reverse) {
        return permission === cooperationShow.hide ? <>{children}</> : <></>;
    }

    if (permission === cooperationShow.hide) {
        return null;
    }
    if (permission === cooperationShow.available && !cls) {
        return <>{children}</>;
    }

    return (
        <div className={className} onClick={onDisabledClick} ref={ref}>
            {children}
        </div>
    );
};
